import TakeOutAdvanceDdPrompt from 'features/advance/screens/lightning/IntroPage/components/TakeOutAdvanceDdPrompt/TakeOutAdvanceDdPrompt';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

const DdPromptPage = () => {
  return (
    <PinwheelContextProvider>
      <TakeOutAdvanceDdPrompt />
    </PinwheelContextProvider>
  );
};

export default DdPromptPage;
